// React
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
// App files
import App from "./App";
import "./index.css";
import ReactGA from 'react-ga4';
import store from "./reducers/index";

//ReactGA.initialize('');

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById("root")
);
